import React from 'react';
import { Link } from 'react-router-dom';

const AppDevelopment = () => {
    const services = [
        {
            icon: '🍎',
            title: 'iOS Development',
            description: 'Native iOS applications built with Swift for optimal performance on iPhone and iPad.'
        },
        {
            icon: '🤖',
            title: 'Android Development',
            description: 'Native Android apps using Kotlin for seamless experiences across all Android devices.'
        },
        {
            icon: '🔄',
            title: 'Cross-Platform Apps',
            description: 'React Native and Flutter apps that work beautifully on both iOS and Android.'
        },
        {
            icon: '🎨',
            title: 'UI/UX Design',
            description: 'Intuitive, engaging app interfaces designed for maximum user satisfaction.'
        },
        {
            icon: '🔧',
            title: 'App Maintenance',
            description: 'Ongoing updates, bug fixes, and feature enhancements to keep your app current.'
        },
        {
            icon: '📊',
            title: 'App Analytics',
            description: 'Insights and analytics integration to understand user behavior and optimize performance.'
        }
    ];

    const workProcess = [
        { step: '01', title: 'Ideation', description: 'Define goals and requirements' },
        { step: '02', title: 'Design', description: 'Create UI/UX mockups' },
        { step: '03', title: 'Development', description: 'Build the application' },
        { step: '04', title: 'Testing', description: 'Quality assurance' },
        { step: '05', title: 'Launch', description: 'App store deployment' },
        { step: '06', title: 'Support', description: 'Ongoing maintenance' }
    ];

    return (
        <div className="page">
            {/* Hero Section */}
            <section className="page-hero" style={{ background: `linear-gradient(rgba(8,15,30,0.75) 0%, rgba(8,15,30,0.55) 100%), url(${process.env.PUBLIC_URL}/images/team-overhead.jpg) center/cover no-repeat`, color: 'white' }}>
                <div className="page-hero-content container">
                    <h1>App <span className="text-gradient">Development</span></h1>
                    <p>
                        Native and cross-platform mobile applications that deliver exceptional
                        user experiences and drive business results.
                    </p>
                </div>
            </section>

            {/* Services Section */}
            <section className="section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our <span className="text-gradient">Services</span></h2>
                        <p>Full-cycle mobile app development for iOS and Android</p>
                    </div>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <div key={index} className="card card-gradient service-card">
                                <div className="service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Process Section */}
            <section className="section bg-dark">
                <div className="container">
                    <div className="section-header">
                        <h2>Development <span className="text-gradient">Process</span></h2>
                        <p>Our proven methodology for successful app delivery</p>
                    </div>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                        gap: '1rem'
                    }}>
                        {workProcess.map((item, index) => (
                            <div
                                key={index}
                                className="card"
                                style={{ textAlign: 'center', padding: '1.5rem' }}
                            >
                                <span
                                    className="text-gradient"
                                    style={{ fontSize: '1.5rem', fontWeight: '800' }}
                                >
                                    {item.step}
                                </span>
                                <h4 style={{ margin: '0.5rem 0' }}>{item.title}</h4>
                                <p className="text-muted" style={{ fontSize: '0.875rem' }}>
                                    {item.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section">
                <div className="container">
                    <div className="cta-section">
                        <div className="cta-content">
                            <h2>Have an App Idea?</h2>
                            <p>
                                Let's turn your vision into a successful mobile application.
                            </p>
                            <Link to="/contact" className="btn btn-primary">
                                Start Your App Project →
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AppDevelopment;
